const IGNORED_MESSAGES = [
  /Script error/,
  /Blocked a frame with origin/,
  /Extension context invalidated/,
  /cancelled/,
  /NotSupportedError/,
  /Can't add property Accessibility/
]

const options = {
  accessToken: process.env.ROLLBAR_ACCESS_TOKEN,
  autoInstrument: true,
  captureUncaught: true,
  captureUnhandledRejections: true,
  checkIgnore: (isUncaught, args, payload) => {
    const message = (payload.body.trace && payload.body.trace.exception && payload.body.trace.exception.description) || ''
    const idx = IGNORED_MESSAGES.findIndex((regex) => {
      return regex.test(message)
    })

    return (idx > -1)
  },
  payload: {
    environment: process.env.ROLLBAR_ENVIRONMENT,
    code_version: process.env.REVISION,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.REVISION
      }
    }
  }
}

export default options
